<template>
    <div class="pring_card-carousel">
        <el-carousel 
        :interval="5000" 
        height="301px" 
        :autoplay='false' 
        trigger='click'
        @change="changePage"
        ref="carousel"
        indicator-position="none" arrow="never">
            <el-carousel-item v-for="item in 4" :key="item">
                <div class="cardItemBox">
                    <div class="cardItem">
                        <div class="pring-cardIcon"></div>
                        <p class="p_cardText">
                            "Lorem Ipsum is simply dummy text of the <br/>
                            printing and typesetting industry. Lorem Ipsum <br/>
                            has been the industry's standard dummy."
                        </p>
                        <img src="../../assets/home/checked.png" class="p_cardUserIcon" alt="">
                        <p class="p_cardUsername">Thomas Phillips</p>
                        <p class="p_cardUserJob">CEO, Brightsight</p>
                    </div>
                    <div class="cardItem">
                        <div class="pring-cardIcon"></div>
                        <p class="p_cardText">
                            "Lorem Ipsum is simply dummy text of the <br/>
                            printing and typesetting industry. Lorem Ipsum <br/>
                            has been the industry's standard dummy."
                        </p>
                        <img src="../../assets/home/checked.png" class="p_cardUserIcon" alt="">
                        <p class="p_cardUsername">Thomas Phillips</p>
                        <p class="p_cardUserJob">CEO, Brightsight</p>
                    </div>
                </div>
            </el-carousel-item>
        </el-carousel>
        <ul class="indicator_des">
            <li v-for="item in 4" :key="item" class="indicatorBtn" :class="{'indicatorBtn_active':active==item-1}"></li>
            <li class="prev_btn" @click="prev"></li>
            <li class="next_btn" @click="next"></li>
        </ul>
    </div>
</template>

<script>
export default {
    data() {
        return {
            active:0
        }
    },
    methods: {
        changePage(val){
            console.log(val);
            this.active = val
        },
        prev(){
            this.$refs.carousel.setActiveItem(this.active-1)
        },
        next(){
            this.$refs.carousel.setActiveItem(this.active+1)
        }
    }
}
</script>

<style lang='scss' scoped>
.pring_card-carousel{
    width: 1080px;
    margin: 0 auto;
    .cardItemBox{
        display: flex;
        position: relative;
        z-index: 10;
        .cardItem{
            position: relative;
            z-index: 10;
            width: 530px;
            min-height: 301px;
            border-radius: 4px;
            background: #4E4C4A;
            padding: 30px;
            &:first-child{
                margin-right: 20px;
            }
            .pring-cardIcon{
                width: 37px;
                height: 26px;
                margin: 0 auto 24px auto;
                background: url('../../assets/home/pring-card.png') no-repeat;
                background-size: contain;
            }
            .p_cardText{
                text-align: center;
                font-size: 20px;
                font-family: Lora-Roman, Lora;
                font-weight: normal;
                line-height: 24px;
                color: #FFFFFF;
                opacity: 1;
            }
            .p_cardUserIcon{
                display: block;
                margin: 24px auto 15px auto;
                width: 40px;
                height: 40px;
                border-radius: 50%;
            }
            .p_cardUsername{
                text-align: center;
                font-size: 15px;
                font-weight: bold;
                line-height: 22px;
            }
            .p_cardUserJob{
                text-align: center;
                margin-top: 3px;
                font-size: 15px;
                font-weight: 400;
                line-height: 22px;
                color: #FFFFFF;
                opacity: 0.8;
            }
        }
    }
    .indicator_des{
        height: 43px;
        align-items: center;
        margin-top: 30px;
        display: flex;
        position: relative;
        z-index: 10;
        .indicatorBtn{
            width: 10px;
            height: 10px;
            background: #5E5C59;
            border-radius: 50%;
            padding: 0;
            opacity: 1;
            margin-right: 10px;
            &:first-child{
                margin-left: 495px;
            }
        }
        .indicatorBtn_active{
            background:#F8A4AE;
        }
        .prev_btn{
            margin-left: auto;
            width: 43px;
            height: 43px;
            background: url('../../assets/home/prev.png') no-repeat;
            background-size: contain;
        }
        .next_btn{
            margin-left: 20px;
            width: 43px;
            height: 43px;
            background: url('../../assets/home/next.png') no-repeat;
            background-size: contain;
            cursor: pointer;
        }
    }
    /deep/{
        .el-carousel{
            position: relative;
            z-index: 10;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/common/card-carousel.vue